import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5fc00e68"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "evolution"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = {
  key: 1,
  class: "evolution"
};
const _hoisted_6 = {
  class: "text negative"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_9 = {
  class: "text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_col = _resolveComponent("b-col");
  const _component_colorful_big_bar = _resolveComponent("colorful-big-bar");
  const _component_FlexRow = _resolveComponent("FlexRow");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_b_col, null, {
    default: _withCtx(() => [_createVNode(_component_hug_value, {
      loading: $props.loading,
      align: $props.fields[0].justify,
      styles: {
        padding: '8px'
      }
    }, {
      default: _withCtx(() => [!$options.showEvolution ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("   ")], 64)) : (_openBlock(), _createBlock(_component_percentage_value, {
        key: 1,
        precision: 1,
        value: $props.value.period_evolution.period1,
        loading: $props.loading
      }, null, 8, ["value", "loading"]))]),
      _: 1
    }, 8, ["loading", "align"])]),
    _: 1
  }), _createVNode(_component_b_col, null, {
    default: _withCtx(() => [_createVNode(_component_hug_value, {
      loading: $props.loading,
      align: $props.fields[1].justify,
      styles: {
        padding: '8px'
      }
    }, {
      default: _withCtx(() => [!$options.showEvolution ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("   ")], 64)) : (_openBlock(), _createBlock(_component_percentage_value, {
        key: 1,
        precision: 1,
        value: $props.value.period_evolution.period2,
        loading: $props.loading
      }, null, 8, ["value", "loading"]))]),
      _: 1
    }, 8, ["loading", "align"])]),
    _: 1
  }), _createVNode(_component_b_col, {
    class: "evolution-column"
  }, {
    default: _withCtx(() => [_createVNode(_component_hug_value, {
      loading: $props.loading,
      align: $props.fields[2].justify,
      styles: {
        padding: '4px'
      }
    }, {
      default: _withCtx(() => [!$options.showEvolution ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4)) : $props.value.evolution_pp ? (_openBlock(), _createElementBlock("div", _hoisted_5, [$props.value.evolution_pp < 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_FlexRow, {
        styles: {
          justifyContent: 'flex-end'
        },
        class: "evolution-value negative"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_percentage_value, {
          align: "left",
          value: $props.value.evolution_pp,
          pp: "",
          precision: 1
        }, null, 8, ["value"])]), _createVNode(_component_colorful_big_bar, {
          value: Math.abs($props.value.evolution_pp),
          height: "26px",
          min: 0,
          max: $props.minMax.evolution_pp.max,
          background: "#FFE5E7",
          borderColor: "#DB333B"
        }, null, 8, ["value", "max"])]),
        _: 1
      }), _hoisted_7], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_8, _createVNode(_component_FlexRow, {
        styles: {
          justifyContent: 'flex-start'
        },
        class: "evolution-value positive"
      }, {
        default: _withCtx(() => [_createVNode(_component_colorful_big_bar, {
          value: Math.abs($props.value.evolution_pp),
          height: "26px",
          min: 0,
          max: $props.minMax.evolution_pp.max,
          background: "#DEFBE6",
          borderColor: "#22863D"
        }, null, 8, ["value", "max"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_percentage_value, {
          align: "left",
          value: $props.value.evolution_pp,
          pp: "",
          precision: 1
        }, null, 8, ["value"])])]),
        _: 1
      })], 64))])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["loading", "align"])]),
    _: 1
  })], 64);
}